<!-- 赠送书币操作 -->
<template>
<div>
	<div id="" :style="{'width':table_scroll_width + 'px',}">
	<div :style="{'width':body_width - 60 + 'px',}" style="position: sticky;left: 30px;z-index: 5;">
		<!-- 标题 -->
		<div class="page-title">赠送书币记录</div>
		
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 0;">
			<!-- <div class="screen-box">
				<div class="screen-label">注册日期</div>
				<dateRangePicker :date_width="300" :before_number="date_number"
				@onGetDate="onGetDate"></dateRangePicker>
			</div> -->
			
			<div v-if="Object.keys(opIdData).length > 0" class="screen-box">
				<div class="screen-label">操作人员</div>
				<a-select
					show-search
					style="width: 200px"
					placeholder="请选择操作人员"
					@change="handleChangeO"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<!-- <a-select-option v-for="(item,index) in opIdData" :key="index" :value="item.key">
					  {{item.value}}
					</a-select-option> -->
					<a-select-option v-for="(value,key) in opIdData" :key="key" :value="key">
					  {{value}}
					</a-select-option>
				</a-select>
				
			</div>
			
			<!-- <div class="screen-box">
				<div class="screen-label">渠道/书城</div>
				<a-select
					style="min-width: 200px"
					placeholder="请选择书城"
					@change="handleChangeA"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					showSearch
					allowClear
				  >
					<a-select-option v-for="(item,index) in filterList.channel_id.list" :key="index" :value="item.key">
					  {{item.value}}
					</a-select-option>
				</a-select>
			</div> -->
			
			<div class="screen-box">
				<div class="screen-label">公众号</div>
				<!-- @popupScroll="popupScrollG" -->
				<a-select
					style="min-width: 200px"
					placeholder="请选择公众号"
					:filter-option="filterOption"
					@change="handleChangeB"
					:getPopupContainer="getsPopupContainer" 
					showSearch
					allowClear
					:value="r_gzh_id"
				  >
					<!-- <a-select-option v-for="(item,index) in filterList.gzh_id.list" :key="index" :value="item.key">
					  {{item.value}}
					</a-select-option> -->
					<a-select-option v-for="(item,index) in gzhSelectData" :key="index" :value="item.key">
					  {{item.value}}
					</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">用户ID</div>
				<a-input v-model="r_user_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">Openid</div>
				<a-input v-model="r_openid" allowClear placeholder="请输入" style="width: 280px;"  />
			</div>
			
			<a-button @click="searchButton('button')" :loading="search_button_loading" class="screen-box" type="primary" icon="search">搜索</a-button>
			
		</div>
	</div>
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div   class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<div class="table-th-cell-sticky" style="display: flex;align-items: center;">
					<template v-for="(item,index) in rableTitle" name="item.type">
						<div v-if="index <= sticky_index" class="table-th-cell" style="cursor: default;"
						:style="{'width':rableTitle[index].width + 'px'}" >
							{{rableTitle[index].title}}
						</div>
					</template>
				</div>
			</div>
			<div v-for="(item,index) in rableTitle" :key="index" >
				<div v-if="index > sticky_index" class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<template v-for="(z_tem,z_ndex) in rableTitle">
					<div v-if="z_ndex <= sticky_index" class="table-td-cell"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						{{item[z_tem.type]}}
					</div>
				</template>
			</div>
			
			<template v-for="(z_tem,z_ndex) in rableTitle">
				<div v-if="z_ndex > sticky_index && z_tem.type != 'status' && z_tem.type != 'cz'" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type]}}
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'status'" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type] == 1?'成功':'失败'}}
				</div>
			</template>
		</div>
		
		<!-- 表格内容为空时显示 -->
		<tableNull :tableShowData="tableShowData" :table_null_width="table_null_width"></tableNull>
		
		<!-- 分页 -->
		<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="table_null_width"
		:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
		@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	</div>
	
	
	
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import { putDataMenu, regGzhList,  orderGzhCustomReport, regGzhReport, otherCurrency, otherCurrencyLog, logSelectUser } from '@/request/api'
export default {
	name: 'giftCurrencyLog_',
	components: {},
	data() {
		return {
			startTime: '2020-05-01', // 投放日期-开始时间
			endTime: '2022-06-30', // 投放日期-结束时间
			filterList: { // 搜索条件内容
				channel_id: {},
				gzh_id: {},
				op_id:{}, // 投手
			}, 
			gzhSelectData: [], // 某追书云渠道下的公众号选择
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID", width:90, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				// {title:"用户ID", width:100, type:"user_id", },
				{title:"公众号", width:100, type:"gzh_name", },
				// 第三方平台用户id
				{title:"用户ID", width:120, type:"third_user_id", },
				// {title:"渠道", width:80, type:"channel_name", },
				{title:"用户OpenId", width:180, type:"openid", },
				
				{title:"赠送书币数量", width:120, type:"coin", },
				{title:"状态", width:90, type:"status", },
				{title:"成功失败原因", width:120, type:"remark", },
				
				{title:"操作人员", width:120, type:"admin_user", },
				
				// {title:"注册时间", width:130, type:"reg_time", },
				
				
				// {title:"操作", width:150, type:"cz", },
			],
			tableShowData: [],
			table_scroll_width: 1600,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			table_null_width: 1500, // 表格内容为空时，空提示的宽度范围
			sticky_index: 3,
			search_button_loading: false, // 搜索按钮的加载状态
			r_page: 1,
			table_total: 0,
			r_limit: 50,
			
			r_channel_id: 102, // 渠道id。赠送书币功能目前只有追书云渠道，追书云渠道ID：102
			r_gzh_id: undefined, // 公众号id
			r_openid: null, // Openid
			r_user_id: null, // 用户ID
			r_admin_id: undefined, // 操作用户ID 或 投手ID
			
			date_number: 7, // x天前的日期
			
			opIdData: {}, // 所有的投手数据，包括超级管理员
		}
	},
	mounted(){
		let that = this
		
		that.search_button_loading = true
		
		// 获取表格信息
		let table_info = this.$getTableInfo(that.rableTitle)
		that.body_width = table_info.body_width
		that.table_scroll_width = table_info.table_width
		that.table_null_width = table_info.null_width
		
		console.log("that.$route.query",this.$route.query)
		if(that.$route.query){
			that.r_channel_id = that.$route.query.chal_id
			that.r_gzh_id = Number(that.$route.query.gzh_id) || undefined
			that.r_openid = that.$route.query.openid
			that.r_user_id = that.$route.query.user_id
		}
		
		setTimeout(()=>{
			// 给母页面的tab传递粘性定位用的参数
			that.$bus.$emit("stickyData", that.table_scroll_width);
		},300)
		
		// 修改母页面的tab选中状态
		// setTimeout(()=>{
			that.$bus.$emit("tabPath", that.$route.fullPath);
		// },100)
		
		// 获取当天日期
		this.endTime = this.$getThisDay()
		// 获取7天前的日期
		this.startTime = this.$getBeforeDay(this.date_number)
		
		
		putDataMenu().then(res=>{
			console.log('putDataMenu',res)
			that.filterList = res.data.data.filter
			
			that.is_admin = res.data.data.is_admin
			let g_data = []
			// 把追书云的公众号筛选出来
			res.data.data.filter.gzh_id.list.forEach(res=>{
				if(res.value.indexOf("追书云") > -1){
					g_data.push(res)
				}
			})
			that.gzhSelectData = g_data
		})
		
		// 获取搜索条件
		logSelectUser().then(res=>{
			console.log('获取搜索条件',res.data.data)
			
			that.opIdData = res.data.data.list
		})
		
		// 搜索
		that.searchButton()
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 日期选择
		onGetDate(date_start, date_end) {
			this.startTime = date_start
			this.endTime = date_end
		},
		handleChangeA(e){ // 渠道/书城
			console.log(e);
			this.r_channel_id = e
		},
		handleChangeB(e){ // 公众号
			console.log(e);
			this.r_gzh_id = e
		},
		handleChangeO(e){ // 投手
			this.r_admin_id = e
		},
		
		// 搜索
		searchButton(type){
			let that = this
			that.search_button_loading = true
			
			// 点击按钮进行条件搜索的时候，要把页数变成1，否则相关内容可能搜索不出来。
			if(type == 'button'){
				that.r_page = 1
			}
			
			otherCurrencyLog({
				// export: 0,
				limit: that.r_limit,
				page: that.r_page,
				start_date: that.startTime.replace(/-/g, ''),
				end_date: that.endTime.replace(/-/g, ''),
				
				channel_id: that.r_channel_id, // 渠道id
				gzh_id: that.r_gzh_id, // 公众号id
				openid: that.r_openid, // Openid
				user_id: that.r_user_id, // 用户ID
				admin_id: that.r_admin_id,
			}).then(res=>{
				console.log('搜索',res);
				that.search_button_loading = false
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					that.table_total = res.data.data.total
					that.tableShowData = res.data.data.data
				}
				else {
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
		},
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.r_page = e
			this.searchButton()
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		
		
	},
	filters: {
		matchTypeFilter(value){
			let mmm = ""
			if(value == 0){
				mmm = "未匹配"
			}
			else if(value == 1){
				mmm = "系统匹配"
			}
			else if(value == 2){
				mmm = "人工匹配"
			}
			else if(value == 3){
				mmm = "系统匹配：IP匹配"
			}
			else if(value == 4){
				mmm = "系统匹配：IP所在地匹配"
			}
			else if(value == 5){
				mmm = "系统匹配：设备ID匹配"
			}
			else if(value == 6){
				mmm = "用户注册表匹配"
			}
			return mmm
		},
		hasReportFilter(value){
			let mmm = ""
			if(value == 0){
				mmm = "不回传"
			}
			else if(value == 1){
				mmm = "已回传"
			}
			else if(value == -1){
				mmm = "未处理"
			}
			return mmm
		}
	}
}
</script>

<style scoped>
.class-title {
	width: 100px;
}

.table-td-cell {
	font-size: 13px;
}
</style>